var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"fill-height":""}},[_c('canvas',{ref:"rendercanvas",staticClass:"renderCanvas",staticStyle:{"height":"100%","width":"100%","cursor":"none!important"},attrs:{"tabindex":"0","id":"rendercanvas"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }